export const demeritPointsFormatter = (demeritPoints: number): string => {
  return demeritPoints && demeritPoints !== 0 ? demeritPoints.toString() : '';
};
